/**
 * useSettings Hook
 *
 * React hooks for accessing and subscribing to settings changes.
 */
import { useState, useEffect, useCallback } from "react";
import { settingsService } from "../services/settingsService";
/**
 * Hook to access and subscribe to Excel export settings
 */
export function useExcelExportSettings() {
    const [excelSettings, setExcelSettings] = useState(settingsService.getExcelExportSettings());
    useEffect(() => {
        // Subscribe to settings changes
        const unsubscribe = settingsService.subscribe((newSettings) => {
            setExcelSettings(newSettings);
        });
        // Get latest settings on mount
        setExcelSettings(settingsService.getExcelExportSettings());
        return unsubscribe;
    }, []);
    const updateExcelExportSettings = useCallback(async (updates) => {
        await settingsService.updateExcelExportSettings(updates);
    }, []);
    return {
        excelSettings,
        updateExcelExportSettings,
        // Convenience getters
        editMode: excelSettings.editMode,
        defaultBlackAndWhite: excelSettings.defaultBlackAndWhite,
        defaultCollapseGroups: excelSettings.defaultCollapseGroups,
    };
}
/**
 * Hook to access and subscribe to model settings
 */
export function useModelSettings() {
    const [modelSettings, setModelSettings] = useState(settingsService.getModelSettings());
    useEffect(() => {
        // Subscribe to settings changes
        const unsubscribe = settingsService.subscribeToModelSettings((newSettings) => {
            setModelSettings(newSettings);
        });
        // Get latest settings on mount
        setModelSettings(settingsService.getModelSettings());
        return unsubscribe;
    }, []);
    const updateModelSettings = useCallback(async (updates) => {
        await settingsService.updateModelSettings(updates);
    }, []);
    return {
        modelSettings,
        updateModelSettings,
        // Convenience getters
        chatModel: modelSettings.chatModel,
        reasoningMode: modelSettings.reasoningMode,
    };
}
export default useExcelExportSettings;
